import type { CommonCtx } from '../schema'
import type { Middleware } from '../tracker'

export function contextEnricher(base: CommonCtx): Middleware {
  return (next) => ({
    track(event, payload, ctx) {
      const merged = { ...base, ...ctx }
      try { next.track(event, payload as any, merged) } catch { /* noop */ }
    }
  })
}

